import { ARABIC } from "../../../../public/Constants/EnumConstants";

export const LABEL = (locale) =>
    locale === ARABIC
        ? "mr-[10px] md:mr-[15px]"
        : "ml-[10px] md:ml-[15px]" +
          " font-normal md:font-medium text-sm md:text-base text-Heading_Black font-Poppins";
